<template>
  <v-layout align-center justify-start>
    <v-flex shrink>
      <v-layout align-center row>
        <v-flex shrink>
          <v-select
            :items="pf"
            return-object
            item-text="name"
            label="Filter Presets"
            v-model="selectedPreset"
            clearable
          />
        </v-flex>
        <v-flex>
          <v-btn
          small
          @click="loadFilterSet"
          color="primary"
          :disabled="!presetSelected"
          >Load Preset</v-btn>
        </v-flex>
        <v-flex>
          <v-btn
          small
          @click="deleteFilterSet"
          color="error"
          v-show="presetSelected"
          :disabled="!presetSelected"
          >Delete Selected Preset</v-btn>
        </v-flex>
      </v-layout>
    </v-flex>

    <v-flex shrink>
      <v-dialog
        v-model="presetDialog"
        max-width='400'
      >
        <v-btn
        slot="activator"
        small
        color="success"
        >Save Current Filters</v-btn>
        <v-card>
          <v-card-text>
          <v-text-field
            label="Preset nickname"
            v-model="newPresetName"
          />
          </v-card-text>
          <v-card-actions>
            <v-btn color="grey" flat @click="presetDialog = false">Nevermind</v-btn>
            <v-btn
              color="success"
              :disabled="!newPresetName"
              @click="saveFilterSet">
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-flex>
  </v-layout>
</template>

<script>

import { mapState } from 'vuex'

export default {
  props: [
    'currentQuery',
  ],

  data() {
    return {
      selectedPreset: null,
      newPresetName: '',
      presetDialog: false,
    }

  },

  created() {
    this.$store.dispatch('profiles/getFilterSets', { filter_type: 'calendar_list' })
  },

  computed: {
    ...mapState('profiles', [
      'filterPresets',
    ]),
    pf() {
      return this.filterPresets
    },
    currentFilterPreset() {
      let { // Clone filters except some fields
        limit, offset, page,
        startDate, endDate,
        ...thisFilterSet
      } = this.currentQuery

      return thisFilterSet
    },

    presetSelected() {
      return !!this.selectedPreset
    }
  },

  methods: {
    saveFilterSet() {
      this.$store.dispatch('profiles/saveFilterSet', {
        filter_type: "calendar_list",
        preset: this.currentFilterPreset,
        name: this.newPresetName,
      })
      .then((r) => {
        this.$store.dispatch('global/showSnackbarSuccess', { message: "Preset saved!" })
      })
      .catch((e) => {
        this.$store.dispatch('global/showSnackbarError', { message: "Problem saving preset. Is the nickname already used?" })
      })
      .finally(() => {
        this.newPresetName = ''
        this.presetDialog = false
      })
    },

    loadFilterSet() {
      if (!this.selectedPreset) {
        return
      }

      this.$emit('updateFilters', this.selectedPreset.preset)
      this.selectedPreset = null
    },

    deleteFilterSet() {
      if (!this.selectedPreset) {
        return
      }

      this.$store.dispatch('profiles/deleteFilterSet', {
        presetID: this.selectedPreset.id
      }).then((r) => {
        this.$store.dispatch('global/showSnackbarSuccess', { message: "Preset deleted!" })
      })
      .finally(() => {
        this.selectedPreset = null
      })
    },

  },
  
}
</script>
